<template>
  <div :class="`base-journey-card base-journey-card--${journey.type} grey--text text--darken-3 mb-3`">
    <v-card rounded="lg" class="grey--text text--darken-3">
      <div class="main d-flex">
        <div :class="`side side--${journey.type}`">
          <div :class="`journey-type journey-type--${journey.type}`">
            <v-avatar tile class="journey-type__avatar rounded-tl-lg" size="49">
              <v-icon dark :color="typeIconColor"> {{ typeIcon }}</v-icon>
            </v-avatar>
            <div :class="`journey-type__text ${typeIconColor}--text`">
              {{ typeName }}
            </div>
          </div>

          <div class="detail-list d-inline">
            <div class="detail-list-item d-flex py-2 px-3" v-for="(d, index) in detailItems" :key="index">
              <div class="detail-list-item__content grey--text text--darken-3">
                <v-icon left class="mt-n1" color="grey text--darken-1">{{ d.icon }}</v-icon> {{ d.label }}
              </div>
              <div class="detail-list-item__value font-weight-medium grey--text text--darken-2" v-text="d.value" />
            </div>
          </div>
        </div>
        <div class="content">
          <div :class="`places places--${journey.type} grey--text text--darken-3`">
            <div class="origin text-body-1 font-weight-bold">
              {{ originFullName }} <span class="text--disabled font-weight-regular ml-2">{{ originTypeDesc }}</span>
            </div>
            <div class="destination text-body-1 font-weight-bold">
              <span class="text--disabled font-weight-regular mr-2">{{ destinationTypeDesc }}</span>
              {{ destinationFullName }}
            </div>
          </div>
          <div
            class="py-1 px-3 text--secondary d-flex align-center"
            style="height: 41px; min-height: 41px !important; border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
            v-if="isEmbarked"
          >
            <div class="embarking-details">
              <v-icon small left>{{ embarkingType === 1 ? 'mdi-ferry' : 'mdi-train' }}</v-icon>
              Imbarcato su <span class="font-weight-regular">{{ embarkingTypeDesc }}</span> da
              <span class="font-weight-regular">{{ embarkingFromFullName }}</span> a
              <span class="font-weight-regular">{{ embarkingToFullName }}</span>
            </div>
          </div>
          <div class="goods">
            <v-simple-table
              v-if="goods.length > 0"
              class="rounded-0"
              dense
              :style="{ 'border-bottom': isStandard ? `` : `1px solid rgba(0, 0, 0, 0.12)` }"
            >
              <template v-if="isStandard">
                <thead>
                  <tr style="height: 41px !important; min-height: 41px !important">
                    <th width="20px" class=""></th>
                    <th class="text-left py-2">Classificazione merce e aspetto</th>
                    <th class="text-right" width="100px">Già a bordo</th>
                    <th class="text-right" width="80px">Caricata</th>
                    <th class="text-right" width="80px">Scaricata</th>
                    <th class="text-right" width="80px">Rimanente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(g, index) in goods"
                    :key="index"
                    style="height: 46px !important; min-height: 46px !important"
                  >
                    <td class="font-weight-medium light-blue--text text--darken-4">
                      <v-icon left class="mt-n1">{{ g.icon }}</v-icon>
                    </td>
                    <td class="py-1">
                      {{ g.typeDesc }}
                      <div class="text--secondary mt-n1">
                        <small>{{ g.cargoTypeDesc }}</small>
                      </div>
                    </td>
                    <td class="text-right weight font-weight-regular text--secondary">
                      {{ g.onboard }} <small class="font-weight-regular text--disabled">q</small>
                    </td>
                    <td class="text-right weight font-weight-bold">
                      {{ g.loaded }} <small class="font-weight-regular text--disabled">q</small>
                    </td>
                    <td class="text-right weight font-weight-bold">
                      {{ g.unloaded }} <small class="font-weight-regular text--disabled">q</small>
                    </td>
                    <td class="text-right weight font-weight-regular">
                      {{ g.remaining }} <small class="font-weight-regular text--disabled">q</small>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-else>
                <thead>
                  <tr style="height: 41px !important; min-height: 41px !important">
                    <th width="160px"></th>
                    <th class="text-left py-2">Classificazione merce e aspetto</th>
                    <th class="text-right">Quantitá</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(g, index) in goods"
                    :key="index"
                    style="height: 46px !important; min-height: 46px !important"
                  >
                    <td class="font-weight-medium light-blue--text text--darken-4">
                      <v-icon left class="mt-n1">{{ g.icon }}</v-icon> {{ g.label }}
                    </td>
                    <td class="py-1">
                      {{ g.typeDesc }}
                      <div class="text--secondary mt-n1">
                        <small>{{ g.cargoTypeDesc }}</small>
                      </div>
                    </td>
                    <td class="text-right weight font-weight-medium">
                      {{ g.weight }} <small class="font-weight-regular text--disabled">q</small>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="py-1 text--secondary mt-auto" style="height: 41px; border-top: 1px solid rgba(0, 0, 0, 0.12)">
            <v-row no-gutters>
              <v-col class="px-3 d-flex align-center">
                <div v-if="isRound">
                  <v-icon small left class="mt-n1">mdi-map-marker</v-icon>
                  <span class="font-weight-medium">{{ journey.stops_count }}</span> fermate (di cui
                  {{ journey.stops_province_count }} nella prov. di partenza)
                </div>
              </v-col>
              <v-col cols="3" class="text-right d-flex justify-end align-center" style="padding-top: 2px">
                <v-btn
                  @click="$emit('click:delete')"
                  depressed
                  text
                  small
                  color="secondary"
                  class="my-0 mr-2"
                  :disabled="disableDelete"
                >
                  Elimina</v-btn
                >
                <v-btn @click="$emit('click:edit')" outlined small text class="my-0 mr-3" color="primary">
                  Modifica</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
// Mixins
import journeyMixin from '@/mixins/journey.mixin'

export default {
  mixins: [journeyMixin],
  props: {
    disableDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    typeName() {
      switch (this.journey.type2) {
        case 13:
          return 'VIAGGIO A VUOTO'
        case 11:
        case 12:
          return 'VIAGGIO STANDARD'
        case 31:
        case 32:
        case 33:
          return 'NAVETTA'
        case 21:
          return 'CIRCUITO RACCOLTA'
        case 22:
          return 'CIRCUITO DISTRIBUZIONE'
        case 23:
          return 'CIRCUITO RACC. e DISTR.'
        default:
          return ''
      }
    },
    typeIcon() {
      switch (this.journey.type) {
        case 1:
          return 'mdi-map-marker-distance'
        case 2:
          return 'mdi-map-marker-path'
        case 3:
          return 'mdi-swap-horizontal-bold'
        case 4:
          return 'mdi-map-marker-outline'
        default:
          return ''
      }
    },
    typeIconColor() {
      switch (this.journey.type) {
        case 1:
          return 'primary'
        case 2:
          return 'purple'
        case 3:
          return 'green'
        case 4:
          return 'blue-grey'
        default:
          return ''
      }
    },
    coupledVehicleDetailItems() {
      if (!this.hasCoupledVehicle) return []

      return [
        {
          label: `${this.coupledVehicleDesc} (port. utile)`,
          icon: 'mdi-truck-trailer',
          value: this.coupledVehicleLoadCapacity,
        },
        {
          label: `${this.coupledVehicleDesc} (assi)`,
          icon: 'mdi-tire',
          value: this.coupledVehicleAxles,
        },
      ]
    },
    shuttleDetailItems() {
      return [
        { label: 'Numero viaggi', icon: 'mdi-swap-horizontal', value: this.journey.journeys_count },
        { label: 'Km con carico', icon: 'mdi-road-variant', value: this.journey.distance_loaded },
        { label: 'Km a vuoto', icon: 'mdi-road-variant', value: this.journey.distance_empty },
        ...this.coupledVehicleDetailItems,
      ]
    },
    roundDetailItems() {
      return [
        { label: 'Numero viaggi', icon: 'mdi-swap-horizontal', value: this.journey.journeys_count },
        { label: 'Km con carico', icon: 'mdi-road-variant', value: this.journey.distance_loaded },
        { label: 'Km a vuoto', icon: 'mdi-road-variant', value: this.journey.distance_empty },
        // { label: 'Fermate totali', icon: 'mdi-map-marker', value: this.journey.stops_count },
        // {
        //   label: ' nella prov. di origine',
        //   icon: 'mdi-map-marker-outline',
        //   value: this.journey.stops_province_count,
        // },
        ...this.coupledVehicleDetailItems,
      ]
    },
    standardDetailItems() {
      return [
        { label: 'Km totali', icon: 'mdi-road-variant', value: this.journey.distance_total },
        ...this.coupledVehicleDetailItems,
      ]
    },
    roundGoods() {
      return [0, 1].map((index) => {
        const labels = ['RACCOLTA', 'DISTRIBUITA']
        const icons = ['mdi-alpha-r-box-outline', 'mdi-alpha-d-box-outline']

        const g = this.journey.goods?.[index]

        return {
          icon: icons[index],
          label: labels[index],
          typeDesc: g ? this.goodsTypeDesc(g) : '–',
          cargoTypeDesc: g ? this.goodsCargoTypeDesc(g) : '',
          weight: g ? `${g.weight}` : '–',
        }
      })
    },
    shuttleGoods() {
      return [0, 1].map((index) => {
        const labels = ['ANDATA', 'RITORNO']
        const icons = ['mdi-arrow-right-bold-circle-outline', 'mdi-arrow-left-bold-circle-outline']

        const g = this.journey.goods?.[index]

        return {
          icon: icons[index],
          label: labels[index],
          typeDesc: g ? this.goodsTypeDesc(g) : '–',
          cargoTypeDesc: g ? this.goodsCargoTypeDesc(g) : '',
          weight: g ? `${g.weight}` : '–',
        }
      })
    },
    standardGoods() {
      return this.journey.goods
        .map((g, index) => {
          if (!g) return
          if (g.is_inherited && g.weights.onboard === 0) return

          return {
            icon: 'mdi-package-variant-closed',
            label: `MERCE ${index + 1}`,
            typeDesc: this.goodsTypeDesc(g),
            cargoTypeDesc: this.goodsCargoTypeDesc(g),
            ...g.weights,
          }
        })
        .filter((g) => !!g)
    },
    detailItems() {
      switch (this.journey.type) {
        case 1:
        case 4:
          return this.standardDetailItems
        case 2:
          return this.roundDetailItems
        case 3:
          return this.shuttleDetailItems
        default:
          return []
      }
    },
    goods() {
      switch (this.journey.type) {
        case 1:
          return this.standardGoods
        case 2:
          return this.roundGoods
        case 3:
          return this.shuttleGoods
        default:
          return []
      }
    },
    coupledVehicleDetails() {
      if (!this.hasCoupledVehicle) return null
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.side {
  width: 300px;
  min-width: 300px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.journey-type {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.detail-list-item {
  // display: flex;
  // flex-direction: row;
  // padding: 6px 12px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &:last-child {
    border-bottom: none;
  }

  &__content {
    flex-grow: 1;
  }
}

.content {
  // background-color: orange;border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.places {
  display: flex;
  column-gap: 1rem;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  // background-color: lawngreen;
  height: 50px;
  max-height: 50px;
  padding: 6px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.journey-type {
  // border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  // padding: 6px 12px;
  font-weight: bold;
  // color: white;
  border-top-left-radius: 4px;
  min-height: 50px;
  display: flex;
  align-content: center;
  align-items: center;
}
</style>
